import type { Table } from '@tanstack/react-table'
import { Maximize2Icon, Minimize2Icon } from 'lucide-react'

import {
  AddFilterButton,
  Button,
  Filters,
  Search,
  TableExport,
} from '@/components'
import type { Transaction } from '@/modules/projects'
import { transactionFilterSchema } from '@/schemas/transactionFilterSchema'
import { useTableFilters } from '@/stores'

interface SectionToolbarProps {
  dialogId: string
  exportFilename: string
  table: Table<Transaction> | null
  hasShareNumber: boolean
  isFullScreen: boolean
  setIsFullScreen: (value: boolean) => void
}

export function SectionToolbar({
  dialogId,
  exportFilename,
  table,
  hasShareNumber,
  isFullScreen,
  setIsFullScreen,
}: SectionToolbarProps) {
  const schema = hasShareNumber
    ? transactionFilterSchema
    : transactionFilterSchema.filter((field) => field.field !== 'shareNumber')

  const { getUniqueValues } = useTableFilters<Transaction>({ table, schema })

  return (
    <div className="flex items-center justify-between gap-4 border-b px-6 py-3">
      <Filters
        dialogId={dialogId}
        schema={schema}
        getUniqueValues={getUniqueValues}
      />
      <div className="flex items-center gap-2">
        <Search />
        <AddFilterButton dialogId={dialogId} schema={schema} />
        {table && <TableExport table={table} filename={exportFilename} />}
        <Button
          theme="outline"
          size="sm"
          isIcon
          onClick={() => setIsFullScreen(!isFullScreen)}
        >
          {isFullScreen ? (
            <Minimize2Icon className="h-4 w-4" />
          ) : (
            <Maximize2Icon className="h-4 w-4" />
          )}
        </Button>
      </div>
    </div>
  )
}
